import { writeQueue } from './write-queue';
import { CRDT } from './crdt';
export class Database {
    static databases = new Map();
    name;
    opts = {};
    _listeners = new Set();
    _crdt;
    _writeQueue;
    constructor(name, opts) {
        this.name = name;
        this.opts = opts || this.opts;
        this._crdt = new CRDT(name, this.opts);
        this._writeQueue = writeQueue(async (updates) => {
            const r = await this._crdt.bulk(updates);
            await this._notify(updates);
            return r;
        });
    }
    async get(id) {
        const got = await this._crdt.get(id).catch(e => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            e.message = `Not found: ${id} - ` + e.message;
            throw e;
        });
        if (!got)
            throw new Error(`Not found: ${id}`);
        const { doc } = got;
        return { _id: id, ...doc };
    }
    async put(doc) {
        const { _id, ...value } = doc;
        const docId = _id || 'f' + Math.random().toString(36).slice(2); // todo uuid v7
        const result = await this._writeQueue.push({ key: docId, value });
        return { id: docId, clock: result?.head };
    }
    async del(id) {
        const result = await this._writeQueue.push({ key: id, del: true });
        return { id, clock: result?.head };
    }
    async changes(since = []) {
        const { result, head } = await this._crdt.changes(since);
        const rows = result.map(({ key, value }) => ({
            key, value: { _id: key, ...value }
        }));
        return { rows, clock: head };
    }
    subscribe(listener) {
        this._listeners.add(listener);
        return () => {
            this._listeners.delete(listener);
        };
    }
    async _notify(updates) {
        if (this._listeners.size) {
            const docs = updates.map(({ key, value }) => ({ _id: key, ...value }));
            for (const listener of this._listeners) {
                await listener(docs);
            }
        }
    }
}
export function database(name, opts) {
    if (!Database.databases.has(name)) {
        Database.databases.set(name, new Database(name, opts));
    }
    return Database.databases.get(name);
}
